import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Item from './Item'
import type { RadioListType } from './types'

const THEMES = {
  labeled: 'labeled',
  toggle: 'toggle',
  menuToggle: 'menuToggle',
}
interface LayoutProps {
  theme: string
}

const Layout = ({ theme, children }: React.PropsWithChildren<LayoutProps>) => {
  switch (theme) {
    case THEMES.labeled:
      return (
        <Box flexDirection="column" justifyContent="center">
          {children}
        </Box>
      )

    case THEMES.toggle:
      return (
        <Box
          flexDirection="row"
          borderRadius={{
            all: 'abs008',
          }}
          padding="s2"
        >
          {children}
        </Box>
      )

    case THEMES.menuToggle:
      return (
        <Box
          flexDirection="row"
          background="grey200"
          padding="s2"
          borderRadius={{
            all: 'abs008',
          }}
        >
          {children}
        </Box>
      )

    default:
      return <div>{children}</div>
  }
}

const RadioGroup: React.FC<RadioListType> = ({
  options,
  name,
  field,
  theme = 'labeled',
  color,
  invisibleRadio = false,
  readonly = false,
}) => {
  return (
    <Layout theme={theme}>
      {options.map((option, index) => (
        <Item
          key={index}
          name={name}
          theme={theme}
          color={color}
          option={option}
          invisible={Boolean(invisibleRadio)}
          readonly={readonly}
          field={field}
        />
      ))}
    </Layout>
  )
}

export default observer(RadioGroup)
